import React from "react";
import classes from "./howItWorksArtistModal.module.css";

const HowItWorksArtistModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modal}>
        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>
            How It Works – For Artists (Join the Platform)
          </h2>
          <button className={classes.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>
        <div className={classes.modalContent}>
          <div className={classes.modalTagline}>
            Turn your talent into paid gigs. Join the spotlight.
          </div>

          <div className={classes.stepsContainer}>
            <div className={classes.step}>
              <div className={classes.stepNumber}>1</div>
              <div className={classes.stepContent}>
                <h3>Create Your Profile</h3>
                <ul>
                  <li>
                    Sign up and fill in your details (genre, availability,
                    performance type).
                  </li>
                  <li>Add videos, photos, bio, and pricing.</li>
                </ul>
              </div>
            </div>

            <div className={classes.step}>
              <div className={classes.stepNumber}>2</div>
              <div className={classes.stepContent}>
                <h3>Get Verified</h3>
                <ul>
                  <li>Our team quickly reviews your profile.</li>
                  <li>Once approved, you go live on the platform.</li>
                </ul>
              </div>
            </div>

            <div className={classes.step}>
              <div className={classes.stepNumber}>3</div>
              <div className={classes.stepContent}>
                <h3>Receive Bookings</h3>
                <ul>
                  <li>
                    Users send booking requests with all necessary event info.
                  </li>
                  <li>You get notified via email & dashboard.</li>
                </ul>
              </div>
            </div>

            <div className={classes.step}>
              <div className={classes.stepNumber}>4</div>
              <div className={classes.stepContent}>
                <h3>Accept or Decline</h3>
                <ul>
                  <li>Accept bookings within the required timeframe.</li>
                  <li>Confirmed bookings = guaranteed gigs.</li>
                </ul>
              </div>
            </div>

            <div className={classes.step}>
              <div className={classes.stepNumber}>5</div>
              <div className={classes.stepContent}>
                <h3>Perform & Get Paid</h3>
                <ul>
                  <li>Show up, do your thing, and we handle the payment.</li>
                  <li>Payments are processed after successful completion.</li>
                </ul>
              </div>
            </div>

            <div className={classes.step}>
              <div className={classes.stepNumber}>6</div>
              <div className={classes.stepContent}>
                <h3>Grow with Reviews</h3>
                <ul>
                  <li>Get rated by users to build your reputation.</li>
                  <li>Higher ratings = more gigs, better visibility.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksArtistModal;
